const BASE_URL = "https://2d916f75.ngrok.io";
export const SERVICES_URL = BASE_URL.concat("/services");
export const IMAGES_URL = BASE_URL.concat("/images");
